<template>
  <v-container fluid class="d-flex flex-column justify-center height-100-percent">
    <v-row align-content="center">
      <v-col
          cols="12"
          sm="10" offset-sm="1"
          md="8" offset-md="2"
          lg="6" offset-lg="3"
          xl="4" offset-xl="4"
      >
        <v-card elevation="1">
          <v-card-title class="headline">
            <span class="title">Change Password</span>
          </v-card-title>
          <v-card-text>
            <form @submit.prevent @keyup.enter="submit">
              <v-text-field
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                  :type="showPassword ? 'text' : 'password'"
                  v-model="password"
                  :error-messages="passwordErrors()"
                  label="New Password"
                  required
                  filled
                  @blur="$v.password.$touch()"
              ></v-text-field>
              <v-text-field
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                  :type="showPassword ? 'text' : 'password'"
                  v-model="password_confirmation"
                  :error-messages="passwordConfirmationErrors()"
                  label="Confirm Password"
                  required
                  filled
                  @blur="$v.password_confirmation.$touch()"
              ></v-text-field>
              <v-fade-transition>
                <v-progress-linear
                    v-if="score.value > 0"
                    :color="score.color"
                    :value="score.value"
                    height="25"
                >
                  <template v-slot:default="{ value }">
                    <span>{{ score.text }}</span>
                  </template>
                </v-progress-linear>
              </v-fade-transition>
              <v-btn
                  class="mt-4"
                  @click="submit"
                  :disabled="submitted || $v.$invalid"
                  color="primary"
              >
                Change Password
              </v-btn>
            </form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {validationMixin} from "vuelidate"
import {displayErrors} from '../helpers/AppHelper'
import {mapMutations, mapGetters} from "vuex"
import passwordFormMixin from "../mixins/passwordFormMixin"

export default {
  name: "AppExpiredPassword",
  mixins: [validationMixin, passwordFormMixin],
  computed: {
    ...mapGetters(['getUser']),
  },
  methods: {
    ...mapMutations(['setLoggedIn']),
    submit() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      this.submitted = true
      this.$store.dispatch('auth/resetExpiredPassword', this.password)
          .then(() => {
            this.setLoggedIn({...this.getUser, force_password_reset: '0'})
            this.$router.push({name: 'inspections'}).catch((e) => {
              console.log(e)
            })
          })
          .catch((err) => {
            displayErrors(err)
            this.submitted = false
          })
    },
  },
}
</script>